import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { renderFieldDisabled, CustomCurrencyDisabled, CustomDollarDisabled } from '../../../../../Utils/renderField/renderField';
import { renderField } from "../../../../../Utils/renderField/renderField"
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { 
    CurrencyDisplay, 
    isSalidaRow, 
    getCellStyles, 
    renderSectionHeaderAnnual,
    separateFieldsByTypeAnnual,
    formatCurrency
} from './CashFlowComponentsAnnual';
import { TYPE_OF_FLOW } from '../../../../../../../utility/constants';
import './CashFlow.css';


const TableRow = ({ system, index, fields, currency, change, year_list }) => {

    const isNew = fields.get(index).isNew;
    const currentField = fields.get(index);
    
    // Usar las constantes TYPE_OF_FLOW correctamente
    const isSalida = currentField.type_of_flow === TYPE_OF_FLOW.SALIDAS || 
                     currentField.type_of_flow === 40 ||
                     isSalidaRow(currentField);

    React.useEffect(() => {
        change(`${system}.is_dollar`, currency === 'USD');
    }, [currency, system, change]);

    // Styles 
    const disabledStyle = isSalida ? { color: '#dc3545', fontWeight: '500' } : { fontWeight: '500' }

    return (
        <React.Fragment key={index}>
            <tr key={`system-${index}`} style={{minWidth: "200px"}}>
                <td className='first-column table-form-fixed-cell-left-0'>
                    <Field
                        name={`${system}.name`}
                        type="text"
                        style={disabledStyle}
                        component={isNew ? renderField : renderFieldDisabled}
                        className="form-control"
                        placeholder='Nuevo'
                    />
                </td>
                {year_list.map((year) => {
                    return (
                        <td key={year} style={{ width: "6.9%" }}>
                            <Field
                                name={`${system}.${year}`}
                                type="text"
                                component={
                                    currency === 'USD' ?
                                        CustomDollarDisabled
                                        :
                                        CustomCurrencyDisabled
                                }
                                disabledStyle={disabledStyle}
                                placeholder={fields.get(index).is_dollar ? '$ 0.00' : 'Q 0.00'}
                                isSalida={isSalida}
                            />
                        </td>
                    );
                })}
            </tr>
        </React.Fragment>
    );
};

const GenericTable = ({ fields, allValues, change, currency, year_list }) => {
    const [collapsed, setCollapsed] = React.useState(false);
    
    // Separar campos por tipo - EXACTAMENTE como en mensual
    const { ingresos, salidas } = separateFieldsByTypeAnnual(fields);
    
    const calculateTotalForMonth = (year) => {
        const allFields = fields.getAll() || [];
        let total = allFields.reduce((total, system) => {
            if (system.isTitulo) return total; // Excluir títulos
            
            let value = parseFloat(system[year]) || 0;
            return total + value;
        }, 0);
        return total;
    };
    
    const columnas = year_list.map((year, index) => (
        <th key={index} style={{ width: `${100 / year_list.length}%` }}>{year}</th>
    ));

    return (
        <div className=" col-sm-12 form-group np-r p-0">
            <div className='table-responsive report-scroll-content cash-flow'>
                <table className="table table-striped mb-0">
                    <thead onClick={() => setCollapsed(!collapsed)} style={{ cursor: 'pointer' }}>
                        <tr>
                            <th className='first-column table-form-fixed-cell-left-0 titulo-left-padded' style={{ color: "#2d5016" }}>
                                <div className="d-flex align-items-center">
                                    <span className="mr-2" style={{ fontSize: '14px' }}>
                                        {collapsed ? '▶' : '▼'}
                                    </span>
                                    FLUJOS FINANCIEROS
                                </div>
                            </th>
                            {columnas}
                        </tr>
                    </thead>
                    <tbody style={{ backgroundColor: "#F0FFC7" }}>
                        {/* Títulos - siempre visibles */}
                        {fields.getAll() && fields.getAll().map((field, index) => {
                            if (field.isTitulo) {
                                return (
                                    <TableRow
                                        key={`titulo-${index}`}
                                        system={`financial.${index}`}
                                        index={index}
                                        fields={fields}
                                        change={change}
                                        currency={currency}
                                        year_list={year_list} />
                                );
                            }
                            return null;
                        })}

                        {!collapsed && (
                            <React.Fragment>
                                {ingresos.length > 0 && renderSectionHeaderAnnual('INGRESOS', '#d4edda', ingresos, currency, year_list)}
                                {ingresos.map(({ field, index }) =>
                                    <TableRow
                                        key={`ingreso-${index}`}
                                        system={`financial.${index}`}
                                        index={index}
                                        fields={fields}
                                        change={change}
                                        currency={currency}
                                        year_list={year_list} />
                                )}
                                
                                {salidas.length > 0 && renderSectionHeaderAnnual('SALIDAS', '#f8d7da', salidas, currency, year_list)}
                                {salidas.map(({ field, index }) =>
                                    <TableRow
                                        key={`salida-${index}`}
                                        system={`financial.${index}`}
                                        index={index}
                                        fields={fields}
                                        change={change}
                                        currency={currency}
                                        year_list={year_list} />
                                )}
                            </React.Fragment>
                        )}

                        {collapsed && (
                            <React.Fragment>
                                {ingresos.length > 0 && renderSectionHeaderAnnual('INGRESOS', '#d4edda', ingresos, currency, year_list)}
                                {salidas.length > 0 && renderSectionHeaderAnnual('SALIDAS', '#f8d7da', salidas, currency, year_list)}
                            </React.Fragment>
                        )}

                        {currency !== 'USD' ?
                            (<tr className="celda-totales">
                                <td className='table-form-fixed-cell-left-0 titulo-left-padded'>DIFERENCIA Q</td>
                                {year_list.map((year, idx) => (
                                    <td key={idx} className='text-right-padded'>
                                        {formatCurrency(calculateTotalForMonth(year), currency, calculateTotalForMonth(year) < 0)}
                                    </td>
                                ))}
                            </tr>)
                            :
                            (
                                <tr className="celda-totales">
                                    <td className='table-form-fixed-cell-left-0 titulo-left-padded'>DIFERENCIA $</td>
                                    {year_list.map((year, idx) => (
                                        <td key={idx} className='text-right-padded'>
                                            {formatCurrency(calculateTotalForMonth(year), currency, calculateTotalForMonth(year) < 0)}
                                        </td>
                                    ))}
                                </tr>)
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}

const FincancialCashDetailTable = ({ allValues, change, currency, year_list }) => {
    if (!year_list || year_list.length === 0) {
        return <p>Cargando datos...</p>;
    }
    return (
        <div>
            <FieldArray
                name={`financial`}
                component={GenericTable}
                allValues={allValues}
                change={change}
                currency={currency}
                year_list={year_list}
            />
        </div>
    );
}

const formName = 'CashFlowForm';

const selector = formValueSelector(formName);

const mapStateToProps = (state) => {

    const categoryBudget = selector(state, 'financial') || [];
    const allValues = categoryBudget.map(item => item);
    return { allValues };

};

export default connect(mapStateToProps)(FincancialCashDetailTable);